import type { CityConfig } from "../city-template/types";

export const livoniaConfig: CityConfig = {
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — marriage license issuance" },
    { label: "Divorce Records — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Livonia",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "livonia",
  route: "/livonia",
  title: "Emergency Passport Livonia, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Livonia, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Livonia, Canton, Westland, Redford, and Farmington families. Detroit Passport Agency access. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Livonia, MI",
  heroSubtitle: "Livonia families and professionals trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Located in western Wayne County, Livonia is home to the largest suburban school district in Michigan. Our registered couriers serve all of western Detroit metro. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20residential%20neighborhood%20in%20Livonia%20Michigan%20during%20autumn%20with%20well-kept%20single-family%20homes%2C%20tree-lined%20streets%20with%20colorful%20fall%20foliage%2C%20American%20suburban%20architecture%2C%20peaceful%20family%20community%20atmosphere%2C%20golden%20afternoon%20light%2C%20clean%20and%20green%20environment%2C%20no%20text%20no%20people%2C%20high%20quality%20real%20estate%20photography%20style&width=1800&height=700&seq=livonia-hero-001&orientation=landscape",
  heroImageAlt: "Livonia Michigan suburban neighborhood with tree-lined streets and family homes",
  geoPosition: "42.3684;-83.3527",
  geoPlacename: "Livonia, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 20 miles east in downtown Detroit — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Livonia", zips: "48150, 48151, 48152, 48153, 48154" },
    { name: "Canton", zips: "48187, 48188" },
    { name: "Westland", zips: "48185, 48186" },
    { name: "Redford", zips: "48239, 48240" },
    { name: "Farmington", zips: "48331, 48332, 48333, 48334, 48335, 48336" },
    { name: "Plymouth", zips: "48170, 48173" },
    { name: "Northville", zips: "48167, 48168, 48169" },
    { name: "Garden City", zips: "48135, 48136" },
    { name: "Inkster", zips: "48141, 48142" },
    { name: "Wayne", zips: "48184" },
    { name: "Dearborn Heights", zips: "48125, 48127" },
    { name: "Taylor", zips: "48180" },
    { name: "Romulus", zips: "48174, 48175" },
    { name: "Novi", zips: "48374, 48375, 48376, 48377" },
    { name: "Farmington Hills", zips: "48331, 48333, 48334, 48335, 48336" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Western Wayne County", desc: "Serving Livonia, Canton, Westland, Redford, and Farmington" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — drop off at any UPS or FedEx" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/detroit" },
    { name: "Emergency passport services in Canton, MI", route: "/canton-mi" },
    { name: "Urgent passport services in Farmington Hills, MI", route: "/farmington-hills" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Livonia, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Livonia residents can ship from any UPS or FedEx in western Wayne County.",
  fpcOfficeDistance: "Serving Livonia, Canton, Westland, Redford, Farmington, Plymouth, Northville, Garden City, and all of western Wayne County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Livonia and the western Wayne County suburbs. From the historic Old Redford neighborhood to the Schoolcraft College area, from the Detroit Metro Airport corridor to the western border with Oakland County — we serve all of Livonia and surrounding communities.",
  nearbyCitiesIntro: "We serve Livonia and all western Wayne County communities including Canton, Westland, Redford, Farmington, Plymouth, Northville, Garden City, Inkster, Wayne, Dearborn Heights, and Taylor. We also serve neighboring Oakland County communities through our Farmington Hills and Novi connections.",
  howItWorksIntro: "Most Livonia travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Livonia's large suburban families often discover passport issues before planned vacations or family reunions. Here are the most common passport mistakes we see from western Wayne County travelers.",
  testimonialsIntro: "Livonia travelers — from families with school-age children to retirees planning cruises — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Livonia, MI? Here are the most common ones we hear from western Wayne County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for families and business travelers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Livonia travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Livonia adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Livonia address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Livonia residents and families — including students, new citizens, and young families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Livonia residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Livonia families planning international vacations.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Livonia residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Livonia MI", description: "Urgent passport processing for Livonia Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Livonia MI", description: "Fast passport renewal for Livonia Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Livonia MI", description: "New passport application services for Livonia Michigan residents applying for their first passport." },
    { name: "Child Passport Livonia MI", description: "Minor passport services for Livonia Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Susan M.",
      location: "Livonia, MI",
      rating: 5,
      text: "Family cruise to the Caribbean with 9 days notice. Three passports for our kids and one renewal for me. Fast Passport Center had everything ready in 4 days. We shipped from the UPS Store on Middlebelt and it was so easy.",
      service: "Family Passport Bundle",
    },
    {
      name: "Mark R.",
      location: "Canton, MI",
      rating: 5,
      text: "Business trip to Toronto and I realized my passport had expired. Fast Passport Center got my renewal done in 2 days. Dropped documents at the Livonia FedEx and they handled the rest.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer L.",
      location: "Westland, MI",
      rating: 5,
      text: "My daughter's passport was damaged right before our trip to Mexico. Fast Passport Center walked us through the replacement process and had it in our hands in 48 hours. Thank you!",
      service: "Damaged Passport Replacement",
    },
    {
      name: "Robert K.",
      location: "Livonia, MI",
      rating: 5,
      text: "Needed to renew for a work trip to Germany. The process was incredibly smooth — filled out the form online, shipped from my local UPS, and got my passport back faster than expected.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "livonia-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20 miles east in downtown Detroit",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "livonia-2",
      name: "Livonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11840 Merriman Rd",
      city: "Livonia",
      state: "MI",
      zip: "48150",
      phone: "(734) 422-1400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Livonia — near I-96 and Merriman Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Livonia residents. Appointments required. Convenient for western Wayne County communities.",
      icon: "ri-mail-line",
    },
    {
      id: "livonia-3",
      name: "Canton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7400 N Canton Center Rd",
      city: "Canton",
      state: "MI",
      zip: "48187",
      phone: "(734) 453-4270",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Canton — approximately 5 miles south of Livonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Canton and south Livonia residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "livonia-4",
      name: "Westland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6301 N Wayne Rd",
      city: "Westland",
      state: "MI",
      zip: "48185",
      phone: "(734) 728-5300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Westland — approximately 4 miles south of Livonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Westland and southeast Livonia residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "livonia-5",
      name: "Farmington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "32805 W 12 Mile Rd",
      city: "Farmington",
      state: "MI",
      zip: "48334",
      phone: "(248) 477-3370",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Farmington — approximately 6 miles north of Livonia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Livonia and Farmington residents. Convenient for the Middlebelt and Grand River area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Livonia" },
    { feature: "Family Passport Support", agency: "No tailored advice", fpc: "Yes — group processing for families" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Livonia families often discover passport issues before planned vacations or school breaks. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using the Wrong Passport Document",
      description: "Passport cards are popular for Canada land crossings but are not valid for air travel. If you fly internationally, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Livonia-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-parent-line",
      title: "Not Understanding Child Passport Requirements",
      description: "Children under 16 require both parents' consent and must appear in person. Livonia families often get turned away at the acceptance facility because one parent is missing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Livonia." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Livonia, Canton, or Westland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Livonia-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport facility to Livonia?", a: "The nearest passport acceptance facility is the Livonia Post Office at 11840 Merriman Rd. The Detroit Passport Agency at 211 W. Fort St, Suite 1300 is the nearest regional agency for expedited processing. Fast Passport Center's couriers have direct access to the Detroit Passport Agency without you needing an appointment." },
    { q: "How fast can I get an emergency passport in Livonia?", a: "Fast Passport Center offers emergency passport processing in Livonia, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive to downtown Detroit." },
    { q: "Can Livonia residents get a passport for the whole family?", a: "Absolutely. Fast Passport Center specializes in family passport bundles. We handle multiple applications together — including first-time passports for children and renewals for parents. Our document review ensures every family member's application is correct before submission." },
    { q: "Do I need to go to the Detroit Passport Agency in person?", a: "No. With Fast Passport Center, you ship your documents from Livonia and we handle the in-person submission at the Detroit Passport Agency for you. Our registered courier is authorized by the U.S. Department of State to submit applications on your behalf." },
    { q: "What is the closest airport to Livonia for international travel?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is approximately 15 minutes from Livonia via I-96. DTW is the primary international departure hub for Metro Detroit with direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other international destinations." },
    { q: "How much does an expedited passport cost in Livonia, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Livonia residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Livonia and Canton offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the suburbs around Livonia?", a: "Yes. We serve all of western Wayne County including Canton, Westland, Redford, Garden City, Inkster, Wayne, Plymouth, and Northville. We also serve neighboring Oakland County communities including Farmington, Farmington Hills, Novi, and Southfield." },
  ],
  photoLocations: [
    { name: "Walgreens — Livonia", address: "28440 7 Mile Rd, Livonia, MI 48152", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Canton", address: "44575 Ford Rd, Canton, MI 48187", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Livonia", address: "17900 Newburgh Rd, Livonia, MI 48152", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Westland", address: "6500 N Wayne Rd, Westland, MI 48185", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Livonia", address: "17176 Farmington Rd, Livonia, MI 48152", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Canton", address: "44935 Ford Rd, Canton, MI 48187", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Canton and south Livonia communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "15 minutes from Livonia via I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Closest major airport to Livonia.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "30 minutes from Livonia via I-96 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for travelers crossing to Canada first. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};